import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createEcomCategory = (_, params) => {
  return Api(endPoints.createEcomCategory, params, requestType.POST);
};

const getAllEcomCategory = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.name) queryParams.append("name", params.name);

  const finalUrl = queryParams.toString() ?
    `${endPoints.getAllEcomCategory}?${queryParams.toString()}` :
    endPoints.getAllEcomCategory;

  return Api(finalUrl, null, requestType.GET);
};

const updateEcomCategory = (id, params) => {
  return Api(`${endPoints.updateEcomCategory}/${id}`, params, requestType.PUT);
};

const deleteEcomCategory = (id) => {
  return Api(`${endPoints.deleteEcomCategory}/${id}`, null, requestType.DELETE);
};

const updateEcomCategoryStatus = (id, params) => {
  return Api(`${endPoints.updateEcomCategoryStatus}/${id}`, params, requestType.PATCH);
};

export {
  createEcomCategory,
  getAllEcomCategory,
  updateEcomCategory,
  deleteEcomCategory,
  updateEcomCategoryStatus,
};
